import { render } from "./MoodTrackerInstruction.vue?vue&type=template&id=4167b0f0&scoped=true"
import script from "./MoodTrackerInstruction.vue?vue&type=script&lang=js"
export * from "./MoodTrackerInstruction.vue?vue&type=script&lang=js"

import "./MoodTrackerInstruction.vue?vue&type=style&index=0&id=4167b0f0&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4167b0f0"]])

export default __exports__